<template>
  <div class="CopyOperation">
      <div class="box1">
        <div class="box1_top_title">抄作业</div>
        <div class="box1_button">
          <div class="box1_button_text1" :class="{'box1_button_text2':nav1 == 1}" @click="changenav1(1)">国家队</div>
          <div class="box1_button_text1" :class="{'box1_button_text2':nav1 == 2}" @click="changenav1(2)">养老保险</div>
          <div class="box1_button_text1" :class="{'box1_button_text2':nav1 == 3}" @click="changenav1(3)">国外主权</div>
          <div class="box1_button_text1" :class="{'box1_button_text2':nav1 == 4}" @click="changenav1(4)">知名公募</div>
          <div class="box1_button_text1" :class="{'box1_button_text2':nav1 == 5}" @click="changenav1(5)">知名私募</div>
          <div class="box1_button_text1" :class="{'box1_button_text2':nav1 == 6}" @click="changenav1(6)">知名牛募</div>
        </div>
        <div class="box1_button2">
          <div class="box1_button2_text1">高领资本<img src="../../../public/img/CopyOperation/xiala.png" alt=""></div>
          <div class="box1_button2_text1">交易板块<img src="../../../public/img/CopyOperation/xiala.png" alt=""></div>
          <div class="box1_button2_text1">股票<img src="../../../public/img/CopyOperation/xiala.png" alt=""></div>
        </div>
        <Table1></Table1>
      </div>
  </div>
</template>

<script>
import Table1 from './table/table1.vue'
export default {
  data(){
    return {
      nav1:1,
    }
  },
  methods:{
    changenav1(e){
      this.nav1 = e
    }
  },
  components: {
    Table1,
  },
}
</script>

<style scoped>
.CopyOperation{

}
.box1{
  width: calc(100% - 48px);
  padding: 35px 24px;
  border-radius: 3px;
  background-color: #fff;
}
.box1_top_title{
  font-size: 24px;
  line-height: 1;
	font-weight: bold;
	color: #000000;
  position: relative;
  margin-left: 12px;
}
.box1_top_title::after{
  content: '';
  display: block;
  width: 3px;
	height: 23px;
	background-color: #fcad2a;
	border-radius: 2px;
  position: absolute;
  left: -10px;
  top: 0;
}
.box1_button{
  width: 100%;
  height: 63px;
  line-height: 63px;
  display: flex;
  border-bottom: 1px solid rgba(223,223,223,0.3);
  
}
.box1_button_text1{
  margin-left: 22px;
	font-size: 16px;
	color: #666666;
  cursor: pointer;
}
.box1_button_text1:nth-child(1){
  margin-left: 0
}
.box1_button_text2{
  color: #fcad2a;
  position: relative;
}
.box1_button_text2::after{
  content: '';
  display:block;
  width: 100%;
	height: 3px;
	background-color: #fcad2a;
	border-radius: 2px;
  position: absolute;
  bottom: 0;
}
.box1_button2{
  width: 100%;
  display: flex;
  margin-top: 30px;
  margin-bottom: 20px;
}
.box1_button2_text1{
 padding: 6px 11px;
  line-height: 1;
  text-align: center;
  background-color: rgba(252,173,42,0.06);
  color: #fcad2a;
  font-size: 12px;
  margin-left: 18px;
}
.box1_button2_text1:nth-child(1){
  margin-left: 0;
}
.box1_button2_text1 img{
  width: 9px;
  height: 5px;
  vertical-align: middle;
  margin-left: 7px;
}
@import url('../../../public/css/public.css');
</style>